import { BufferGeometry, Float32BufferAttribute, OrthographicCamera } from "three";
/**
 * Generate a unit quad with variable number of vertices per dimension
 * @param width Number of vertices along the horizontal axis
 * @param height Number of vertices along the vertical axis
 * @returns {BufferGeometry}
 */
export function generateQuad(width, height) {
    // Generate vertices and uv coordinates
    const vertices = new Float32Array(width * height * 3);
    const uv = new Float32Array(width * height * 2);
    let v_index = 0;
    let u_index = 0;
    for (let j = 0; j < height; ++j) {
        const y = j / (height - 1);
        // Left side
        vertices[v_index++] = 0.0;
        vertices[v_index++] = y;
        vertices[v_index++] = 0;
        uv[u_index++] = 0.0;
        uv[u_index++] = y;
        // Right side
        vertices[v_index++] = 1.0;
        vertices[v_index++] = y;
        vertices[v_index++] = 0;
        uv[u_index++] = 1.0;
        uv[u_index++] = y;
    }
    // Generate indices
    const indices = new Float32Array((width - 1) * (height - 1) * 6);
    let srcIndex = 0;
    let dstIndex = 0;
    for (let j = 0; j < height - 1; ++j) {
        for (let i = 0; i < width - 1; ++i) {
            const upperLeft = srcIndex;
            const lowerLeft = upperLeft + width;
            const lowerRight = lowerLeft + 1;
            const upperRight = upperLeft + 1;
            indices[dstIndex++] = lowerLeft;
            indices[dstIndex++] = upperLeft;
            indices[dstIndex++] = lowerRight;
            indices[dstIndex++] = upperRight;
            indices[dstIndex++] = lowerRight;
            indices[dstIndex++] = upperLeft;
            ++srcIndex;
        }
        ++srcIndex;
    }
    return new BufferGeometry()
        .setAttribute("position", new Float32BufferAttribute(vertices, 3, false))
        .setAttribute("uv", new Float32BufferAttribute(uv, 2, false))
        .setIndex(Array.from(indices));
}
/**
 * Collection of miscellaneous used by the renderer
 */
export class RendererUtils {
}
/**
 * Number of samples of the vertical axis to interpolate over in the geograhpic quad
 */
RendererUtils.GEOGRAHPIC_QUAD_Y_SAMPLES = 64;
/**
 * Buffer geometry for a fullscreen quad
 */
RendererUtils.FULLSCREEN_QUAD = generateQuad(2, 2);
/**
 * Buffer geometry for a quad that is to be reprojected into geographic coordinates
 */
RendererUtils.GEOGRAPHIC_QUAD = generateQuad(2, RendererUtils.GEOGRAHPIC_QUAD_Y_SAMPLES);
/**
 * An orthographic camera configuration for pairing with a fullscreen quad to do a full screen pixel shader
 * pass.
 */
RendererUtils.UNIT_ORTHOGRAPHIC = new OrthographicCamera(0, 1, 1, 0, -1, 1);
